import Vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import dySurveyQuery from '@/api/gql/_shared/dynamic-yield/query/survey.gql'

const SlideInSurveyService = {
  async fetchSurvey() {
    const [error, result] = await to(client.query({ query: dySurveyQuery }))
    if (error) Vue.rollbar.error(error.message, error)
    return result?.data?.survey || {}
  },
}

export default SlideInSurveyService
